var map = {
	"./cagayan-cert.webp": 1940,
	"./cert-bg.webp": 1941,
	"./isle-cert.webp": 1942,
	"./license-bg-cn.webp": 1943,
	"./license-bg-mobile-cn.webp": 1944,
	"./license-bg-mobile.webp": 1945,
	"./license-bg.webp": 1946,
	"./pagcor-cert.webp": 1947,
	"./page-bg.webp": 1948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 873;